<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="tagName" >
        <span slot="label" ><a-tooltip>{{$t('标签名称')}}<template slot="title">{{$t('标签名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.tagName" :maxLength="32" :placeholder="$t('请输入')+'标签名称'" />
      </a-form-model-item>
      <a-form-model-item prop="tagIcon" >
        <span slot="label" ><a-tooltip>{{$t('标签图标URL')}}<template slot="title">{{$t('标签图标URL')}}</template></a-tooltip> </span>
        <a-input v-model="form.tagIcon" :maxLength="256" :placeholder="$t('请输入')+'标签图标URL'" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" ><a-tooltip>{{$t('排序值，值越大越靠前')}}<template slot="title">{{$t('排序值，值越大越靠前')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.sort" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'排序值'" />
      </a-form-model-item>
      <a-form-model-item prop="isEnabled" >
        <span slot="label" ><a-tooltip>{{$t('是否启用')}}<template slot="title">{{$t('是否启用')}}</template></a-tooltip> </span>
        <a-select v-model="form.isEnabled" :placeholder="$t('请选择')+'状态'">
          <a-select-option :value="1">{{$t('启用')}}</a-select-option>
          <a-select-option :value="0">{{$t('禁用')}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{$t('备注')}}<template slot="title">{{$t('备注')}}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :maxLength="500" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityInterestTag, addCommunityInterestTag, updateCommunityInterestTag } from '@/api/community/interestTag/interestTag'
  import {mapGetters} from 'vuex'

  export default {
    name: 'CreateForm',
  props: {
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        tagName: null,
        tagIcon: null,
        sort: null,
        isEnabled: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          tagName: [{ required: true, message: this.$t('标签名称')+this.$t('不能为空'), trigger: 'blur' }] ,
          isEnabled: [{ required: true, message: this.$t('是否启用')+this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        tagName: null,
        tagIcon: null,
        sort: null,
        isEnabled: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityInterestTag({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityInterestTag(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('新增成功')
            addCommunityInterestTag(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>